import './styles/main.scss';

// rellax js
let rellax = new Rellax('.rellax');

// aos
AOS.init();

// cursor
const mouseCursor = document.querySelector('.cursor');
const links = document.querySelectorAll('a');
const images = document.querySelectorAll('img');

window.addEventListener('mousemove', (e) => {
  mouseCursor.style.top = e.pageY + 'px';
  mouseCursor.style.left = e.pageX + 'px';
});

links.forEach((link) => {
  link.addEventListener('mouseleave', () => {
    mouseCursor.classList.remove('link__grow');
  });
  link.addEventListener('mouseover', () => {
    mouseCursor.classList.add('link__grow');
  });
});

images.forEach((image) => {
  image.addEventListener('mouseleave', () => {
    mouseCursor.classList.remove('image__grow');
  });
  image.addEventListener('mouseover', () => {
    mouseCursor.classList.add('image__grow');
  });
});
